'use strict';

testContext.$inject = ["config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.testContext = testContext;
/*@ngInject*/
function testContext(config) {
    return {
        restrict: 'A',
        controllerAs: 'vm',
        compile: function compile(elem) {
            if (!config.enableTests) {
                elem.removeAttr();
            } else {
                return {
                    post: function post(scope, element, attribute) {
                        element.addClass(('fb-tst-' + attribute.testContext).toLowerCase());
                    }
                };
            }
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/test-context.js
// module id = 724
// module chunks = 0